module.exports = __webpack_public_path__ + "img/Liputan-Image-1.5bc5dfaf.png";